import type { JsonApiResponse } from 'json-api-normalizer';

import api from 'api/apiInstance';
import type { FilterOptions, GetOptions, PaginationOptions, RequestConfig } from 'api/types';
import type { DocumentPackFilters } from 'constants/documentPackFilters';
import type { Tag } from 'types/entities/clientCase';

export type ClientDocumentPacksGetOptions = GetOptions &
  PaginationOptions &
  FilterOptions<DocumentPackFilters> & { tags?: Tag[] };

export function clientDocumentPacksApi(path: string) {
  return {
    path,
    GET: (params: ClientDocumentPacksGetOptions = {}, config?: RequestConfig) => {
      const { pageSize, pageNumber, ...rest } = params;

      return api.get<JsonApiResponse>(path, {
        params: {
          per_page: pageSize,
          page: pageNumber,
          ...rest,
        },
        ...config,
      });
    },
  };
}
